
import React from "react";
import { Card, CardContent } from "@/components/ui/card";

interface EmptyRequestsStateProps {
  message: string;
}

const EmptyRequestsState: React.FC<EmptyRequestsStateProps> = ({ message }) => {
  return (
    <Card>
      <CardContent className="p-6 text-center">
        <p className="text-muted-foreground">{message}</p>
      </CardContent>
    </Card>
  );
};

export default EmptyRequestsState;
